import { ReactComponent as EthereumLogo } from './ethereum-logo.svg'
import { ReactComponent as LinkdropLogo } from './linkdrop-logo.svg'
import { ReactComponent as LinkdropWhiteLogo } from './linkdrop-white-logo.svg'
import { ReactComponent as LinkdropTextLogo } from './linkdrop-text-logo.svg'
import { ReactComponent as DashboardMenuIcon } from './dashboard-menu-icon.svg'
import { ReactComponent as SupportMenuIcon } from './support-menu-icon.svg'
import { ReactComponent as FaqMenuIcon } from './faq-menu-icon.svg'
import { ReactComponent as DocsMenuIcon } from './docs-menu-icon.svg'
import { ReactComponent as StarMenuIcon } from './star-menu-icon.svg'
import { ReactComponent as GoBackIcon } from './go-back-icon.svg'
import { ReactComponent as DownloadIcon } from './download-icon.svg'
import { ReactComponent as ExternalLinkIcon } from './external-link-icon.svg'
import { ReactComponent as ArrowIcon } from './arrow-icon.svg'
import { ReactComponent as CloseIcon } from './close-icon.svg'
import { ReactComponent as CheckboxIcon } from './checkbox-icon.svg'
import { ReactComponent as DownloadFileIcon } from './csv-download-icon.svg'
import { ReactComponent as SignInIcon } from './sign-in.svg'
import { ReactComponent as BreadcrumbsIcon } from './breadcrumbs-icon.svg'
import { ReactComponent as CampaignsIcon } from './campaigns.svg'
import { ReactComponent as QRManagerIcon } from './qr-manager.svg'
import { ReactComponent as InputNoteIcon } from './input-note-icon.svg'
import { ReactComponent as FileIcon } from './file-icon.svg'
import { ReactComponent as PolygonIcon } from './polygon-icon.svg'
import { ReactComponent as UploadFileIcon } from './upload-file-icon.svg'
import { ReactComponent as NotUploadedIcon } from './not-uploaded-icon.svg'
import { ReactComponent as AttentionIcon } from './attention-icon.svg'
import { ReactComponent as ApprovedIcon } from './approved-icon.svg'
import { ReactComponent as OptionsIcon } from './options-icon.svg'
import { ReactComponent as PauseIcon } from './pause-icon.svg'
import { ReactComponent as UnpauseIcon } from './unpause-icon.svg'
import { ReactComponent as RefundIcon } from './refund-icon.svg'
import { ReactComponent as MiniClipboardCopyIcon } from './mini-clipboard-copy-icon.svg'
import { ReactComponent as ClipboardCopyIcon } from './clipboard-copy-icon.svg'
import { ReactComponent as ClipboardCopiedIcon } from './clipboard-copied-icon.svg'
import { ReactComponent as EyeOpenIcon } from './eye-open-icon.svg'
import { ReactComponent as EyeClosedIcon } from './eye-closed-icon.svg'
import { ReactComponent as MonitorIcon } from './monitor-icon.svg'
import { ReactComponent as YellowAttentionIcon } from './yellow-attention-icon.svg'
import { ReactComponent as TrashIcon } from './trash-icon.svg'
import { ReactComponent as GoToOldVersionIcon } from './go-to-old-version-icon.svg'
import { ReactComponent as ContactUsIcon } from './contact-us-icon.svg'
import { ReactComponent as LegalIcon } from './legal-icon.svg'
import { ReactComponent as CloseCircleIcon } from './close-circle-icon.svg'
import { ReactComponent as BookIcon } from './book-icon.svg'
import { ReactComponent as DispenserIcon } from './dispenser-icon.svg'
import { ReactComponent as EditDispenserIcon } from './edit-dispenser-icon.svg'
import { ReactComponent as StopDispenserIcon } from './stop-icon.svg'
import { ReactComponent as DownloadReportIcon } from './download-report-icon.svg'
import { ReactComponent as PopupWarningIcon } from './popup-warning-icon.svg'
import { ReactComponent as InviteLinksIcon } from './invite-links-icon.svg'
import { ReactComponent as LogoutIcon } from './logout-icon.svg'
import { ReactComponent as MessagesIcon } from './messages-icon.svg'
import { ReactComponent as CodeIcon } from './code-icon.svg'
import { ReactComponent as DynamicQRIcon } from './dynamic-qr-icon.svg'
import { ReactComponent as ExpandRightIcon } from './expand-right-icon.svg'
import { ReactComponent as ArrowRightIcon } from './arrow-right-icon.svg'

import { ReactComponent as DispenserQRIcon } from './dispenser-qr-icon.svg'
import { ReactComponent as ClaimLinksIcon } from './claim-links-icon.svg'
import { ReactComponent as ClaimQRsIcon } from './claim-qrs-icon.svg'
import { ReactComponent as NFTsIcon } from './nfts-icon.svg'

import { ReactComponent as ExpandArrowVerticalIcon } from './expand-arrow-vertical-icon.svg'

import { ReactComponent as QRSetPreviewIcon } from './qr-set-preview-icon.svg'
import { ReactComponent as DispenserQRPreviewIcon } from './dispenser-qr-preview-icon.svg'
import { ReactComponent as DynamicQRPreviewIcon } from './dynamic-qr-preview-icon.svg'
import { ReactComponent as InformationIcon } from './information-icon.svg'
import { ReactComponent as SunnyCloudIcon } from 'icons/sunny-cloud-icon.svg'
import { ReactComponent as ArchiveIcon } from 'icons/archive-icon.svg'
import { ReactComponent as UndoIcon } from 'icons/undo-icon.svg'

import { ReactComponent as SBTTokensIcon } from './sbt-tokens-icon.svg'
import { ReactComponent as NFTTokensIcon } from './nft-tokens-icon.svg'

const Icons = {
  EthereumLogo,
  ArchiveIcon,
  SBTTokensIcon,
  DownloadFileIcon,
  UndoIcon,
  NFTTokensIcon,
  SunnyCloudIcon,
  InformationIcon,
  QRSetPreviewIcon,
  ExpandArrowVerticalIcon,
  DispenserQRPreviewIcon,
  DynamicQRPreviewIcon,
  DispenserQRIcon,
  ClaimLinksIcon,
  ClaimQRsIcon,
  NFTsIcon,
  DynamicQRIcon,
  MessagesIcon,
  CodeIcon,
  LogoutIcon,
  ClipboardCopiedIcon,
  StopDispenserIcon,
  InviteLinksIcon,
  PopupWarningIcon,
  EditDispenserIcon,
  DownloadReportIcon,
  DispenserIcon,
  GoToOldVersionIcon,
  CloseCircleIcon,
  ExpandRightIcon,
  MiniClipboardCopyIcon,
  BookIcon,
  ContactUsIcon,
  TrashIcon,
  MonitorIcon,
  EyeClosedIcon,
  YellowAttentionIcon,
  ClipboardCopyIcon,
  RefundIcon,
  LegalIcon,
  EyeOpenIcon,
  UnpauseIcon,
  PauseIcon,
  OptionsIcon,
  PolygonIcon,
  ArrowRightIcon,
  AttentionIcon,
  ApprovedIcon,
  UploadFileIcon,
  FileIcon,
  LinkdropLogo,
  NotUploadedIcon,
  LinkdropTextLogo,
  BreadcrumbsIcon,
  InputNoteIcon,
  SignInIcon,
  DashboardMenuIcon,
  SupportMenuIcon,
  FaqMenuIcon,
  DocsMenuIcon,
  StarMenuIcon,
  LinkdropWhiteLogo,
  GoBackIcon,
  DownloadIcon,
  ExternalLinkIcon,
  ArrowIcon,
  CloseIcon,
  QRManagerIcon,
  CampaignsIcon,
  CheckboxIcon
}

export default Icons
